import {
  ghostBtnClass,
  mfgConfirmDialogClass,
  mfgSolidDangerBtnClass,
} from "@/components/manufacturing/manufacturingSurfaceClasses";

/** Confirm permanently deleting inactive selected manufacturing models. */
export function ManufacturingModelsBulkPermanentDeleteConfirm({
  open,
  inactiveCount,
  skippedActiveCount,
  busy,
  error,
  blockersSummary,
  onCancel,
  onConfirm,
}: {
  open: boolean;
  inactiveCount: number;
  skippedActiveCount: number;
  busy: boolean;
  error: string | null;
  blockersSummary: string | null;
  onCancel: () => void;
  onConfirm: () => void;
}) {
  if (!open || inactiveCount <= 0) return null;
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="mfg-models-bulk-permanent-delete-title"
      onClick={busy ? undefined : onCancel}
    >
      <div
        className={`max-w-md ${mfgConfirmDialogClass}`}
        onClick={(e) => e.stopPropagation()}
      >
        <h3
          id="mfg-models-bulk-permanent-delete-title"
          className="text-base font-semibold text-gray-900 dark:text-zinc-100"
        >
          Permanently delete {inactiveCount} inactive model
          {inactiveCount === 1 ? "" : "s"}?
        </h3>
        <p className="text-sm text-gray-600 dark:text-zinc-400">
          This removes inactive models and their BOM lines from your organization. This cannot
          be undone. Deletion is blocked while other deals, units, or BOMs still reference a
          model.
          {skippedActiveCount > 0
            ? ` ${skippedActiveCount} still-active selected model${
                skippedActiveCount === 1 ? "" : "s"
              } will be skipped — archive them first.`
            : null}
        </p>
        {blockersSummary ? (
          <p className="text-sm text-amber-800 dark:text-amber-200">{blockersSummary}</p>
        ) : null}
        {error ? (
          <div className="rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-900 dark:border-red-800 dark:bg-red-950/35 dark:text-red-100">
            {error}
          </div>
        ) : null}
        <div className="flex justify-end gap-2 pt-1">
          <button type="button" className={ghostBtnClass} onClick={onCancel} disabled={busy}>
            Cancel
          </button>
          <button
            type="button"
            className={mfgSolidDangerBtnClass}
            onClick={onConfirm}
            disabled={busy}
            autoFocus
          >
            {busy ? "Deleting…" : "Delete permanently"}
          </button>
        </div>
      </div>
    </div>
  );
}
